<script lang="ts">
	import type { SbImage, SbTextColor } from '../types';
	import Image from '../components/image.svelte';
	import PageGrid from '../components/pageGrid.svelte';
	import SbRichtext from '../components/sbRichtext.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	export let content: ISbStoryData<{
		title: string;
		text: ISbRichtext | string;
		text_color: SbTextColor;
		button: ISbStoryData['content'][];
		image: SbImage;
	}>['content'];
</script>

<section use:editable={content}>
	<PageGrid>
		<div class="relative col-span-full min-h-[286px] overflow-hidden rounded-2xl">
			<Image
				src={content.image.filename}
				class="h-full w-full object-cover"
				alt={content.image.alt ?? ''}
				title={content.image.title ?? ''}
				width={1250}
				sizes={{ 1024: { width: 1680 } }}
			/>
			<div class="absolute inset-0 bg-brown-1/40"></div>

			<div
				class="absolute inset-0 flex flex-col justify-between p-5 lg:justify-center lg:pl-[120px] text-{content.text_color ||
					'stone-5'}"
			>
				<div>
					<h1 class="font-serif text-[36px]/[135%] tracking-[-1.12px] lg:text-[56px]/[124%]">
						{content.title}
					</h1>
					<div class="mt-2 text-[18px]/[140%] lg:text-[24px]">
						<SbRichtext text={content.text} />
					</div>
				</div>
				<div class="mt-4 flex lg:mt-10">
					<Blok content={content.button[0]} />
				</div>
			</div>
		</div>
	</PageGrid>
</section>
